import { Droppable } from "@hello-pangea/dnd";
import { AddIcon, Button, EmptyState, KanbanColumn } from "@all-manager/design-system-v2";
import type { IncidentDatabase } from "../../../../../types";
import IncidentKanbanCard from "../IncidentKanbanCard/IncidentKanbanCard";
import { useIncidentKanbanColumn } from "./useIncidentKanbanColumn";

type Props = {
  droppableId: 'in_progress' | 'resolved';
  title: string;
  incidents: IncidentDatabase[];
  isResolvedColumn: boolean;
  onStatusChange?: (incidentId: string, newStatus: 'in_progress' | 'resolved') => void;
  onEdit?: (incident: IncidentDatabase) => void;
  onAddIncident?: () => void;
};

export default function IncidentKanbanColumn(props: Props) {
  const { count, countBadge } = useIncidentKanbanColumn(props);

  return (
    <Droppable droppableId={props.droppableId}>
      {(provided, snapshot) => (
        <KanbanColumn
          title={props.title}
          state={props.isResolvedColumn ? 'done' : 'pending'}
          count={count}
          countLabel={countBadge}
          isDropTarget={snapshot.isDraggingOver}
          bodyRef={provided.innerRef}
          bodyProps={{ ...provided.droppableProps }}
        >
          {props.incidents.length === 0 ? (
            <EmptyState
              title={props.isResolvedColumn ? 'Aucun incident terminé' : 'Aucun incident en cours'}
              subtitle={props.isResolvedColumn
                ? 'Glissez ici un incident résolu, ou marquez-le comme terminé depuis sa carte.'
                : 'Signalez une panne ou un dégât pour suivre sa résolution.'}
              action={!props.isResolvedColumn && props.onAddIncident ? (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<AddIcon fontSize="small" />}
                  onClick={props.onAddIncident}
                >
                  Signaler un incident
                </Button>
              ) : undefined}
            />
          ) : (
            props.incidents.map((incident, index) => (
              <IncidentKanbanCard
                key={incident.id}
                incident={incident}
                index={index}
                onStatusChange={props.onStatusChange}
                onEdit={props.onEdit}
              />
            ))
          )}
          {provided.placeholder}
        </KanbanColumn>
      )}
    </Droppable>
  );
}
